<template>
  <div id="siteContent" class="site-content">
    <breadcrumb v-if="currentRoute !== 404 && currentRoute !== 'Post'" />
    <component :is="currentPage"></component>
  </div>
</template>

<script>
import { PageStore } from 'stores/Page/Page.ts';
import { storeToRefs } from 'pinia';
import { defineAsyncComponent, defineComponent } from 'vue';
import Breadcrumb from 'components/Template/Breadcrumb.vue';
import { useMeta } from 'quasar';

export default defineComponent({
  name: 'DynamicPages',

  components: { Breadcrumb },

  setup() {
    const pageStore = PageStore();
    const { head, currentRoute, breadcrumbs } = storeToRefs(pageStore);

    // const navTitles = breadcrumbs.value.map((o) => o.name);
    //
    // useMeta({
    //   title: head.value.title.siteTitle,
    //   titleTemplate: (title) => `${navTitles.join(' - ')} | ${title}`,
    // });

    return {
      currentRoute,
      currentPage: null,
    };
  },

  created() {
    if (this.currentRoute !== 404) {
      this.currentPage = defineAsyncComponent(() => import(`./DynamicPages/${this.currentRoute}.vue`));
    } else {
      this.currentPage = defineAsyncComponent(() => import('./ErrorNotFound.vue'));
    }
  },
  // watch: {
  //   currentRoute: {
  //     handler() {
  //       if (this.currentRoute === 404) {
  //         this.$router.push('pages/ErrorNotFound.vue');
  //       }
  //     },
  //     immediate: true,
  //   },
  // },
});
</script>
